import AliasEqualsConverter from '../AliasEqualsConverter';
export default AliasEqualsConverter.create('locator.events.resetRequestState');